import React, { useState, useEffect } from 'react';
import '../../css/cards.css';
import Card from './Card';


function Cards({allCards}) { 
  // console.log("cards being rendered")

// console.log(allCards)

// let cardIdArray = [];

// function makeArrayFromDisplayedCards() {

//   allCards.map(card => {
//     cardIdArray.push(card.id)
//   })
//   }

//   makeArrayFromDisplayedCards()

//   if (cardIdArray === undefined) {
//     return <div> Loading! </div>
// } 


  // let luckyCard = cardIdArray[Math.floor(Math.random()*cardIdArray.length)];
  // console.log(`Lucky card: ${luckyCard}`);

// console.log(cardIdArray)

  return (
    <>
      <div id="cards">

      {allCards.map(card => {
        return (
          <Card 
            key={card.id} 
            {...card}
            // cardIdArray={cardIdArray}  
            // luckyCard={luckyCard}
          />
       )
      })}

      </div>
    </>
  )
}

export default Cards;
